import React from "react";
import { ReactComponent as CardIcon } from "../../images/card-icon.svg";
import './card.css';

export default function Card({ title, description, className }) {
  return (
    <div
      className={`p-6 bg-white card-border-radius border border-gray-200 shadow-md card-wrapper ${className}`}
    >
      <div className="flex items-center mb-4">
        <CardIcon className="mr-3 card-icon" />
        <h5 className="card-title">
          {title}
        </h5>
      </div>
      <p className="mb-3 card-desc">{description}</p>
    </div>
  );
}
